import { Component, EventEmitter, Input, OnInit, Output, OnChanges, OnDestroy } from '@angular/core';
import { GlobalVariableService } from 'src/app/core/services/global-variable.service';
import { SharedDataService } from 'src/app/core/services/shared-data.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-solde-analyse',
  templateUrl: './solde-analyse.component.html',
  styleUrls: ['./solde-analyse.component.css']
})
export class SoldeAnalyseComponent implements OnInit {
  public clickEventSubscription: Subscription;

  @Output() refreshSoldes = new EventEmitter();
  @Input() details_solde;

  public detailsSoldeAM: any;
  public detailsSoldeIC: any;
  public detailsSoldeOE: any;
  public detailsSolde: any;
  public user: any;

  constructor(
    private variable: GlobalVariableService,
    private sharedService: SharedDataService,
  ) {
    //refresh page to update table solde
    // this.refresh.emit()
    this.clickEventSubscription = this.sharedService.getClickEventRefreshTableSoldesAnalyse().subscribe(() => {
      this.getSoldesAnalyse();
      // location.reload();
    });
  }


  ngOnInit() {
    this.user = JSON.parse(this.variable.getUser());
    this.getSoldesAnalyse();
  }

  ngOnChanges() {
    this.getSoldesAnalyse();
    // this.detailsSolde;
  }

  ngOnDestroy() {
    /* Always unsubscribe (or use takeUntil, etc.) */
    if (this.clickEventSubscription) {
      this.clickEventSubscription.unsubscribe();
    }
  }


  getSoldesAnalyse() {
    this.detailsSoldeAM = this.details_solde?.AM;
    this.detailsSoldeIC = this.details_solde?.IC;
    this.detailsSoldeOE = this.details_solde?.OE;
    this.detailsSolde = this.details_solde;
    //refresh page to update table solde
    this.refreshSoldes.emit("refresh");
  }
}
